import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { Form } from "antd";
import { useAppDispatch, useAppSelector } from "../../../..";
import { TypesCharacteristicsList } from "../TypesCharacteristicsList/TypesCharacteristicsList";
import { checkIsLoaded } from "../../../../lib/utils";
import "./TypesCharacteristicsContainer.less";
import { TypesCharacteristicsContext } from "../../context/TypesCharacteristicsContext/TypesCharacteristicsContext";
import { ITypesCharacteristicsContext } from "../../context/TypesCharacteristicsContext/types";
import { ITypesCharacteristicsListSearch } from "../../types/TypesCharacteristicsListSearch";
import {
  fetchTypesCharacteristicsObjectTypesDic,
  fetchTypesCharacteristicsRangeTypesDic,
  fetchTypesCharacteristicsTypesDic,
  fetchTypesCharacteristicsTypesUnitsDic,
  fetchTypesCharacteristicsTypesValuesDic,
  searchTypesCharacteristics,
  fetchTypesCharacteristicsTypesDataDic,
} from "../../store/slice/typesCharacteristicsSlice";

import { TypesCharacteristicsCreate } from "../TypesCharacteristicsCreate/TypesCharacteristicsCreate";
import { TypesCharacteristicsView } from "../TypesCharacteristicsView/TypesCharacteristicsView";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_CHAR_TYPE_WRITE } from "../../../../lib/const/permissions";

export const TypesCharacteristicsContainer = () => {
  const dispatch = useAppDispatch();
  const {
    typesCharacteristicsTypesDataDicLoading,
    typesCharacteristicsTypesDicLoading,
    typesCharacteristicsTypesValuesDicLoading,
    typesCharacteristicsTypesUnitsDicLoading,
    typesCharacteristicsRangeTypesDicLoading,
    typesCharacteristicsObjectTypesDicLoading,
  } = useAppSelector((store) => store.typesCharacteristics);

  // Загрузка справочников
  useEffect(() => {
    if (!checkIsLoaded(typesCharacteristicsTypesDataDicLoading))
      dispatch(fetchTypesCharacteristicsTypesDataDic());
    if (!checkIsLoaded(typesCharacteristicsTypesDicLoading))
      dispatch(fetchTypesCharacteristicsTypesDic());
    if (!checkIsLoaded(typesCharacteristicsTypesValuesDicLoading))
      dispatch(fetchTypesCharacteristicsTypesValuesDic());
    if (!checkIsLoaded(typesCharacteristicsTypesUnitsDicLoading))
      dispatch(fetchTypesCharacteristicsTypesUnitsDic());
    if (!checkIsLoaded(typesCharacteristicsRangeTypesDicLoading))
      dispatch(fetchTypesCharacteristicsRangeTypesDic());
    if (!checkIsLoaded(typesCharacteristicsObjectTypesDicLoading))
      dispatch(fetchTypesCharacteristicsObjectTypesDic());
  }, []);

  // Загрузка типов характеристик по входу
  useEffect(() => {
    handleTypesCharacteristicsListSearch({ page: 0, size: 10 });
  }, []);

  const [isSearchOpen, setIsSearchOpen] = useState(true);
  const toggleSearchOpen = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const [typesCharacteristicsListSearchForm] = Form.useForm<ITypesCharacteristicsListSearch>();

  const handleTypesCharacteristicsListSearch = (params?: { page?: number; size?: number }) => {
    const page = params?.page || 0;
    const size = params?.size || 10;
    const values: ITypesCharacteristicsListSearch = typesCharacteristicsListSearchForm.getFieldsValue();

    dispatch(searchTypesCharacteristics({ ...values, page, size }));
  };

  const contextValue: ITypesCharacteristicsContext = {
    isSearchOpen,
    toggleSearchOpen,
    handleTypesCharacteristicsListSearch,
    typesCharacteristicsListSearchForm,
  };

  return (
    <TypesCharacteristicsContext.Provider value={contextValue}>
      <div className="container_height inner-row types-characteristics-container">
        <Switch>
          <Route path="/types-characteristics" exact>
            <TypesCharacteristicsList />
          </Route>
          {hasAccess(MENU_ADMIN_CHAR_TYPE_WRITE) && (
            <Route path="/types-characteristics/create">
              <TypesCharacteristicsCreate />
            </Route>
          )}
          <Route path="/types-characteristics/:typesCharacteristicsId">
            <TypesCharacteristicsView />
          </Route>
        </Switch>
      </div>
    </TypesCharacteristicsContext.Provider>
  );
};
